import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../redux/actions/user.actions';
import webServices from '../../services/webServices';
import { pageTitle } from '../../redux/actions/home.actions';
import Spinner from '../general/spinner';
import offer from '../../assets/images/Offer.svg';
import PlanMoreInfoModalComponent from './PlanMoreInfoModalComponent';
import AuthorizeNetPayment from '../../services/AuthorizeNetPayment';
import VerifyStudentEmailPopup from './VerifyStudentEmailPopup';

const GetPayNowBtnComponent = ({ subscribedPlanId, subscribedPlanPriority, isStudentEmailVerified, plan, handelStudentPlanBtnClick, studentPayBtnRef, isPlanExpired }) => {
  const { id: planId, price: planPrice } = plan;

  if (
    ((subscribedPlanId === null || isPlanExpired) || subscribedPlanPriority < plan.priority) &&
    (
      [9, 11].includes(planId) ||
      (planId === 10 && isStudentEmailVerified === 1)
    )
  )
    return (<AuthorizeNetPayment
      planId={planId}
      planAmount={planPrice.toFixed(2)}
      planType='SUBSCRIPTION_PLAN'
      selectedPlan={plan}
      isHidden={0}
      btnRef={planId === 10 ? studentPayBtnRef : null}
    />)

  // if (isPlanExpired || ((subscribedPlanId === null || subscribedPlanPriority < plan.priority) && planId === 10)) return (
  if (((subscribedPlanId === null || isPlanExpired) || subscribedPlanPriority < plan.priority) && planId === 10)
    return (
      <>
        <button type="button" className="btn btn-info theme-btn ml-3 r_color mb-2 mb-md-0" onClick={handelStudentPlanBtnClick}>
          Pay Now
        </button>
        <AuthorizeNetPayment
          planId={planId}
          planAmount={planPrice.toFixed(2)}
          planType='SUBSCRIPTION_PLAN'
          selectedPlan={plan}
          isHidden={1}
          btnRef={studentPayBtnRef}
        />
      </>
    )

  return <></>;
};

/**
 * Price with the cents raised. Was an HTML string injected with
 * dangerouslySetInnerHTML; the <sup> is the only reason it was markup at all.
 * Declared at module scope so it keeps a stable identity across renders.
 */
const PlanPrice = ({ price }) => {
  const [dollars, cents] = Number(price).toFixed(2).split('.');
  return (
    <>
      {`$${dollars}.`}
      <sup>{cents}</sup>
    </>
  );
};

const PlansComponent = () => {
  const bottomRef = useRef();
  const studentPayBtnRef = useRef();
  const dispatch = useDispatch();
  const [plans, setPlans] = useState([]);
  const { current } = useSelector((state) => state.user);

  const [pageData, setPageData] = useState({
    isSpinner: true,
    showPlanMoreInfoModal: false,
    isSubscriptionPurchased: null,
    isStudentEmailVerified: 0,
    isStudentVerifyModalVisible: false,
    subscribedPlanPriority: 0
  });


  useEffect(async () => {
    dispatch(pageTitle('Plans'));

    const resp = await webServices.getUserDetail();
    if (resp && resp.success === true) {
      setPageData((prev) => ({
        ...prev,
        isSubscriptionPurchased: resp.data.plan_subscription_id !== null ? resp.data.currentPlanId : null,
        isStudentEmailVerified: resp.data.is_student_email_verified,
        subscribedPlanPriority: resp.data.currentPlanPriority
      }));

      dispatch(setUser(resp.data));
    }

    (async () => {
      const response = await webServices.getPlans();
      if (response && response.success) {
        setPlans(response.data);
        setTimeout(() => {
          setPageData((prev) => ({ ...prev, isSpinner: false }));
        }, 400);
      }
    })();
  }, []);

  useEffect(() => {
    setPageData((prev) => ({
      ...prev,
      isSubscriptionPurchased: current.plan_subscription_id !== null ? current.currentPlanId : null,
      isStudentEmailVerified: current.is_student_email_verified
    }));
  }, [current]);


  const handelPlanMoreInfoPopupCloseBtn = () => setPageData((prev) => ({ ...prev, showPlanMoreInfoModal: false }));
  const handelPlanMoreInfoPopupShowIcon = () => setPageData((prev) => ({ ...prev, showPlanMoreInfoModal: true }));

  const handelStudentVerifyPopupCloseBtn = () => setPageData((prev) => ({ ...prev, isStudentVerifyModalVisible: false }));
  const handelStudentPlanBtnClick = () => setPageData((prev) => ({ ...prev, isStudentVerifyModalVisible: true }));

  const handelStudentEmailVerifiedBtn = () => {
    if (studentPayBtnRef.current) {
      studentPayBtnRef.current.click();
      handelStudentVerifyPopupCloseBtn();
    }
  };

  const getPlanContainerClass = (planId) => {
    if (planId === 10) return 'student';
    if (planId === 11) return 'vip';
    return 'standard';
  };

  return (
    <>
      <div className="full-page planWrapper">
        <div className="container">
          {pageData.isSpinner ? (
            <Spinner active={pageData.isSpinner} />
          ) : (
            <>
              <h1 className="text-center text-lg-center text-md-center">
                Simple, Transparent Pricing
              </h1>

              {!pageData.isSubscriptionPurchased && (
                <div className="animates_wrapper">
                  <div className="sale glowWrap">
                    {' '}
                    <img
                      src={offer}
                      className="img-rose-fluid"
                      alt="Lovrican rose"
                    />{' '}
                    <span className="">
                      <span className="sun_font">I Love Africa </span> Sale
                    </span>
                    <img
                      src={offer}
                      className="img-rose-fluid"
                      alt="Lovrican rose"
                    />
                  </div>
                </div>
              )}

              <p className="sale_details">
                We keep our pricing simple. Students get 28% off.

                <span className='lear_more'>
                  Learn more
                  <span className='dot_wrapper ml-2' href='/' onClick={handelPlanMoreInfoPopupShowIcon} onKeyDown={() => { }} role='presentation'>
                    <span className='dot' />
                    <span className='dot' />
                    <span className='dot' />
                  </span>
                </span>
              </p>

              <div className="mid-container-outer" ref={bottomRef}>
                <div className="panConatiner">
                  <div className="student_standPlan_wrapper">
                    {plans.length && plans.map(plan => (
                      <div className={`box ${getPlanContainerClass(plan.id)}`}>
                        {plan.id === 10 && <p className='offer'><span>$4.99 (28% off)</span></p>}
                        <h2 className={plan.id !== 10 ? 'mt-4' : ''}>{plan.name}</h2>
                        <div className="plan-details">
                          <div className="nav flex-column nav-pills">
                            <a
                              className="nav-link active"
                              data-toggle="pill"
                              href="/"
                              key={plan.id}
                            >
                              <div className="d-flex justify-content-between align-items-start flex-wrap flex-md-nowrap pan_wrap">
                                <div className="lft d-flex align-items-center">
                                  <div className="icon mr-3">
                                    <i className="fa fa-circle-thin d-none" aria-hidden="true" />
                                    <i className="fa fa-check-circle d-none" aria-hidden="true" />
                                  </div>
                                  <div className="plan_title">
                                    <h3>Lovrican Subscription</h3>
                                  </div>
                                </div>
                                <div className="mr-3">{
                                  pageData.isSubscriptionPurchased === plan.id && current?.isPlanExpired !== true ? (
                                    <div className='subPlan'><i className="fa fa-check mr-2" aria-hidden="true" />Subscribed</div>
                                  ) : ''
                                }</div>
                                <div className="rgt">
                                  <div className="price"><PlanPrice price={plan.price} /></div>
                                  <div className='month mb-2'>per month</div>
                                </div>
                              </div>
                            </a>
                          </div>
                          {/*
                            `plan_details` is HTML authored server-side in the
                            `plans` table, not user input, and the markup is the
                            point — it carries the feature list. Left as raw HTML
                            deliberately. In free mode this screen is unreachable
                            and the only row returned has a plain-text detail.
                          */}
                          {/* eslint-disable-next-line react/no-danger */}
                          <div className="nav flex-column nav-pills" dangerouslySetInnerHTML={{ __html: plan.plan_details }} />
                        </div>
                        <div className='col-12'>
                          <div className="white-border" />
                          <div className='pay_wrapper'>
                            <div className="mobile_plan justify-content-center text-center mobileFooter">
                              {GetPayNowBtnComponent({
                                subscribedPlanId: pageData.isSubscriptionPurchased,
                                subscribedPlanPriority: pageData.subscribedPlanPriority,
                                isStudentEmailVerified: pageData.isStudentEmailVerified,
                                plan,
                                handelStudentPlanBtnClick,
                                studentPayBtnRef,
                                isPlanExpired: current?.isPlanExpired
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <PlanMoreInfoModalComponent show={pageData.showPlanMoreInfoModal} handelClose={handelPlanMoreInfoPopupCloseBtn} />

      <VerifyStudentEmailPopup isModalVisible={pageData.isStudentVerifyModalVisible} handelClose={handelStudentVerifyPopupCloseBtn} handelEmailVerified={handelStudentEmailVerifiedBtn} />
    </>
  );
};

export default PlansComponent;
